import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { I18nService } from './shared/services/i18n/i18n.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent implements OnInit {
  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.i18nService.initLanguages();
  }
}
